/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

export default {
  getLogisticCategoriesList: (params) => {
    return axios.get(API_ENDPOINTS.GET_LOGISTIC_CATEGORIES_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getLogisticCategoryById: (id) => {
    return axios.get(API_ENDPOINTS.GET_LOGISTIC_CATEGORY_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  addLogisticCategory: (data) => {
    return axios.post(API_ENDPOINTS.ADD_LOGISTIC_CATEGORY, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  updateLogisticCategory: (id, data) => {
    return axios.put(API_ENDPOINTS.UPDATE_LOGISTIC_CATEGORY_BY_ID + "/" + id, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  deleteLogisticCategory: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_LOGISTIC_CATEGORY_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
};
